<mat-accordion class="footer-accordion">
    <mat-expansion-panel hideToggle #matExpansionPanel1 [expanded]="openState">
        <mat-expansion-panel-header
            (click)="expandPanel(matExpansionPanel1, $event)"
            [ngClass]="{ expanded: openState }"
        >
            <ng-content select="[header]" />
        </mat-expansion-panel-header>

        <ng-content select="[body]" />
    </mat-expansion-panel>
    @if (displayHandler) {
        <button
            mat-icon-button
            class="button-accordion"
            color="white"
            aria-label="Handler footer"
            (click)="handlerFooter()"
        >
            <mat-icon>{{ openState ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
    }
</mat-accordion>
